export default "__VITE_ASSET__BKdg$YBd__"